<script>
  import MarkdownBlock from '/components/Atoms/MarkdownBlock'
  import CardMainContent from '/components/Widgets/CardMainContent'

  import { formatDate } from '/helper'
  import { _ } from 'svelte-i18n'
  
  export let data

  let body = data.Text.body
  .filter( e => e.__typename === "textBlock_Entry")
  .map( e => e.textBlock)
  .join("\n")

</script>

<section>

  <CardMainContent
    category={$_("category.news")}
    category_link="/news"
    sup={formatDate(new Date(data?.Text?.postDate), 'event-day-month-year')}
    title={data?.Text?.title}
  >
    <MarkdownBlock source={body} />
  </CardMainContent>

</section>

<style lang="scss">
  section {
    @include grid-margin;
  }

</style>